import { CategoriaEnum } from '@acme/auth'
import Dialog from 'global/guides/Dialog'
import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { CriarUsuarioSchema, usuarios } from 'service/api'
import { toast } from 'sonner'
import { NovoUsuarioForm } from '../forms/NovoUsuario'

const REDIRECT_CATEGORIES = [
    CategoriaEnum.Cliente,
    CategoriaEnum.Avaliacao,
    CategoriaEnum.Representante,
]

export default function AdicionarUsuario() {
    const navigate = useNavigate()
    const toggle = () => navigate('/administracao/usuarios')
    const lastCategoriaRef = useRef<number>(CategoriaEnum.Suporte)

    const { mutateAsync, isLoading } = usuarios.mutations.useCreate({
        onSuccess: () => {
            toast.success('Usuário criado com sucesso!')
            usuarios.invalidateQueries()
        },
        onError: (err: any) => {
            toast.error(err.message)
        },
    })

    const handleChange = (values: any) => {
        const categoriaId = values.categoriaId
        if (categoriaId === lastCategoriaRef.current) return
        lastCategoriaRef.current = categoriaId

        if (REDIRECT_CATEGORIES.includes(categoriaId)) {
            toast.info(
                'Para criar este tipo de usuário, utilize o formulário de clientes',
            )
            navigate('/administracao/clientes/adicionar')
        }
    }

    return (
        <Dialog.Root
            open
            onClose={toggle}
            width="36rem"
            loading={isLoading}
            onSubmit={values => mutateAsync(values)}
            onChange={handleChange}
            schema={CriarUsuarioSchema}
            defaultValues={{ categoriaId: CategoriaEnum.Suporte }}
        >
            <Dialog.Title>Criar usuário</Dialog.Title>
            <Dialog.Content dividers>
                <NovoUsuarioForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
